import { FC, useEffect, useState } from 'react'

import { Vendor } from 'commons/types/DTO/bank/companyDetails/vendor'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary, Table } from 'ui/components'

import { handlerServerError } from '@orbit/errors'

import { CompanyVendorsTableProps } from './CompanyVendorsTableProps'
import { columns } from './columns'
import { Filter } from './components/Filter/Filter'
import { useComponentsEssence } from './hooks/useComponentsEssence'
import { useFilterCompanyVendorsWebPage } from './hooks/useFilterCompanyVendorsWebPage'

export const CompanyVendorsTable: FC<CompanyVendorsTableProps> = (props) => {
  const {
    data: { id, vendors, vendorsTotalCount }
  } = props
  const [webPageData, setWebPageData] = useState({
    vendors: vendors,
    vendorsTotalCount: vendorsTotalCount
  })

  useEffect(() => {
    setWebPageData({
      vendors: vendors,
      vendorsTotalCount: vendorsTotalCount
    })
  }, [vendors, vendorsTotalCount])

  const { routine: filterCompanyVendorsWebPage } = useFilterCompanyVendorsWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })

  const { loading, tableState, filterForm, changePagination, clearFilter } = useComponentsEssence(
    id,
    filterCompanyVendorsWebPage
  )

  return (
    <PageSectionPrimary face="outlined" title="Vendors" anchor="vendors">
      <Layer rounded shadowed stretch>
        <Filter
          form={filterForm}
          expanded={tableState.expanded}
          onToggle={tableState.onFilterToggle}
          onClear={clearFilter}
        />
        <Table<Vendor>
          dataQa={TableDataQa.BP_COMPANY_VENDORS}
          columns={columns}
          dataSource={webPageData.vendors.map((el) => ({
            item: el
          }))}
          loading={loading}
          pagination={{
            page: tableState.page,
            size: tableState.size,
            onChange: changePagination,
            total: webPageData.vendorsTotalCount
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
